import * as URLConfig from "../domain";

const config = URLConfig.config;

export default {
	eqLimit: config.jmw + config.jmw_eq_eq + "limits/rmssublimits/",
	eqBankDetails: config.jmw + config.jmw_eq_eq + "fund/bankdetails/",
	commodityLimit: config.jmw + config.jmw_comm + "limits/",
	commodityBankDetails: config.jmw + config.jmw_comm + "fund/bankdetails/",
	eqMaxPayout: config.jmw + config.jmw_eq_eq + "fund/max/payout",
	payin: {
		paymentgatewayurl: config.jmw + config.jmw_eq_eq + "fund/paymentgatewayurl/",
		upistatus: config.jmw + config.jmw_eq_eq + "fund/upistatus/",
		commPayInURL: config.jmw + config.jmw_comm + "fund/payinurl/",
		verifyPayIn: config.jmw + config.jmw_comm + "fund/verify/transferstatus/"
	},
	payout: {
		bankdetails: config.jmw + config.jmw_eq_eq + "fund/bankdetails/v1/",
		bankdetailsComm: config.jmw + config.jmw_comm + "fund/bankdetails/",
		addpayoutEq: config.jmw + config.jmw_eq_eq + "fund/addpayout/",
		addpayoutComm: config.jmw + config.jmw_comm + "fund/addpayout/",
		modifyPayoutEq: config.jmw + config.jmw_eq_eq + "fund/modifypayout/",
		modifyPayoutEComm: config.jmw + config.jmw_comm + "fund/modifypayout/",
		cancelPayoutEq: config.jmw + config.jmw_eq_eq + "fund/cancelpayout/",
		cancelPayoutEComm: config.jmw + config.jmw_comm + "fund/cancelpayout/"
	},
	history: {
		transferstatusEqPayIn: config.jmw + config.jmw_eq_eq + "fund/transferstatus/",
		transferstatusEqPayOut: config.jmw + config.jmw_eq_eq + "fund/transferstatus/v1/",
		transferstatusComm: config.jmw + config.jmw_comm + "fund/transferstatus/"
	},
	pageURL: {
		payinStatus: "/fund-transfer/add-funds/status?status"
	}
};
